import { useStore } from 'effector-react'
import { DEFAULT_REGION_OPTION } from '~/shared/config/constants'
import { pushFx } from '~/shared/lib/history'
import { DrawerComponent } from '~/shared/ui/Drawer'
import { filterHelpers } from '~/shared/ui/ScrollableList'
import { Content, FormValues } from './Content'
import {
  $isCarVehicleCategoryDrawerOpen,
  closeCarVehicleCategoryDrawer,
} from './model'

export function CarVehicleCategoryDrawer() {
  const isOpen = useStore($isCarVehicleCategoryDrawerOpen)

  const handleGoToCatalog = ({ vehicleCategories }: FormValues) => {
    const vehicleCategoryFilter = vehicleCategories?.length
      ? `vehicleCategory=${encodeURIComponent(
          filterHelpers.encodeOptions(vehicleCategories) || '',
        )}`
      : ''

    const regionFilter = `regionCode=${filterHelpers.encodeOption(
      DEFAULT_REGION_OPTION,
    )}`

    const filters = [vehicleCategoryFilter, regionFilter]
      .filter(Boolean)
      .join('&')

    pushFx(`/booking-cars?${filters}`)
    closeCarVehicleCategoryDrawer()
  }

  return (
    <DrawerComponent isShow={isOpen} onCancel={closeCarVehicleCategoryDrawer}>
      <Content onSuccess={handleGoToCatalog} />
    </DrawerComponent>
  )
}
